import { v4 as uuidv4 } from 'uuid';
import directoryData from './data/directory-publishers.json';

function getDirectoryPublishers() {
    this.directoryPublishers = directoryData.publishers;
    this.directoryFilterIndustries = directoryData.filterIndustries;
    this.observed.directoryPublishers = uuidv4();
}

export default getDirectoryPublishers;
